import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, withModifiers as _withModifiers, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createVNode as _createVNode } from "vue"

const _hoisted_1 = { class: "row" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("div", { class: "col-sm-6" }, [
  /*#__PURE__*/_createElementVNode("h1", null, "Report Types")
], -1)
const _hoisted_3 = { class: "col-sm-6 text-right" }
const _hoisted_4 = /*#__PURE__*/_createElementVNode("i", { class: "fas fa-plus" }, null, -1)
const _hoisted_5 = [
  _hoisted_4
]
const _hoisted_6 = {
  key: 0,
  class: "alert alert-warning text-center"
}
const _hoisted_7 = /*#__PURE__*/_createElementVNode("h2", { class: "mt-1 mb-2" }, "No report types found, please add", -1)
const _hoisted_8 = [
  _hoisted_7
]
const _hoisted_9 = {
  key: 1,
  class: "table table-fixed"
}
const _hoisted_10 = /*#__PURE__*/_createElementVNode("thead", null, [
  /*#__PURE__*/_createElementVNode("tr", null, [
    /*#__PURE__*/_createElementVNode("th", {
      class: "align-middle",
      width: "20%"
    }, "System Name"),
    /*#__PURE__*/_createElementVNode("th", {
      class: "align-middle",
      width: "25%"
    }, "Name"),
    /*#__PURE__*/_createElementVNode("th", {
      class: "align-middle",
      width: "30%"
    }, "Display Name"),
    /*#__PURE__*/_createElementVNode("th", { class: "align-middle text-center" }, "Create Allowed"),
    /*#__PURE__*/_createElementVNode("th", { class: "align-middle text-center" }, "Dictionary"),
    /*#__PURE__*/_createElementVNode("th")
  ])
], -1)
const _hoisted_11 = { class: "text-center" }
const _hoisted_12 = { class: "text-center" }
const _hoisted_13 = { class: "text-right" }
const _hoisted_14 = {
  class: "btn-group",
  role: "group",
  "aria-label": "Actions"
}
const _hoisted_15 = ["onClick"]
const _hoisted_16 = /*#__PURE__*/_createElementVNode("i", { class: "fas fa-trash-alt" }, null, -1)
const _hoisted_17 = [
  _hoisted_16
]
const _hoisted_18 = ["onClick"]
const _hoisted_19 = /*#__PURE__*/_createElementVNode("i", { class: "fas fa-pencil-alt" }, null, -1)
const _hoisted_20 = [
  _hoisted_19
]

import { computed, inject, onMounted, ref } from 'vue';
import { useStore } from 'vuex';
import { useToast } from "vue-toastification";
import { DictionaryReportType } from "@/models";
import ReportTypeModal from "@/components/modals/ReportTypeModal.vue";


export default /*#__PURE__*/_defineComponent({
  __name: 'DictionaryReporttypes',
  setup(__props) {

const store = useStore();
const toasted = useToast();
const actProperty: any = inject('actProperty');

const reportTypeModalAdd = ref(null);
const reportTypeModalEdit = ref(null);

const hasBlockingRequests = computed(() => store.getters['app/hasBlockingRequests']);
const reportTypes = computed(() => store.getters['dictionary/reportTypes'] as DictionaryReportType[] | undefined);

const setActiveReportType = (reporttype: DictionaryReportType) => {
  store.commit('dictionary/setActiveReportType', reporttype);
};

const removeReportType = (reporttype: DictionaryReportType) => {
  store.commit('dictionary/removeReportType', reporttype);
};

const showAddDialog = () => {
  setActiveReportType(new DictionaryReportType());
  const modal = reportTypeModalAdd.value;
  modal.init();
  modal.show();
};

const edit = (reporttype: DictionaryReportType) => {
  setActiveReportType(DictionaryReportType.parse(reporttype));
  const modal = reportTypeModalEdit.value;
  modal.init();
  modal.show();
};

const remove = async (reporttype: DictionaryReportType) => {
  actProperty
    .confirmPrompt()
    .then(() => removeReportType(reporttype))
    .then(() => toasted.success("Flag deleted"))
    .catch((err: any) => actProperty.displayError(err));
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", null, [
    _createElementVNode("header", null, [
      _createElementVNode("div", _hoisted_1, [
        _hoisted_2,
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("button", {
            class: "btn btn-outline-primary",
            onClick: _cache[0] || (_cache[0] = _withModifiers(($event: any) => (showAddDialog()), ["prevent"]))
          }, _hoisted_5)
        ])
      ])
    ]),
    ((!reportTypes.value || !reportTypes.value.length) && !hasBlockingRequests.value)
      ? (_openBlock(), _createElementBlock("div", _hoisted_6, _hoisted_8))
      : (_openBlock(), _createElementBlock("table", _hoisted_9, [
          _hoisted_10,
          _createElementVNode("tbody", null, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(reportTypes.value, (reporttype, $typeindex) => {
              return (_openBlock(), _createElementBlock("tr", { key: $typeindex }, [
                _createElementVNode("td", null, _toDisplayString(reporttype.slug), 1),
                _createElementVNode("td", null, _toDisplayString(reporttype.name), 1),
                _createElementVNode("td", null, _toDisplayString(reporttype.displayname), 1),
                _createElementVNode("td", _hoisted_11, [
                  _createElementVNode("i", {
                    class: _normalizeClass(["fas fa-check", { 'text-success': reporttype.createallowed }])
                  }, null, 2)
                ]),
                _createElementVNode("td", _hoisted_12, [
                  _createElementVNode("i", {
                    class: _normalizeClass(["fas fa-check", { 'text-success': reporttype.dictionaryflag }])
                  }, null, 2)
                ]),
                _createElementVNode("td", _hoisted_13, [
                  _createElementVNode("div", _hoisted_14, [
                    _createElementVNode("button", {
                      class: "btn btn-outline-danger",
                      onClick: [
                        ($event: any) => (remove(reporttype)),
                        _cache[1] || (_cache[1] = _withModifiers(() => {}, ["stop"]))
                      ]
                    }, _hoisted_17, 8, _hoisted_15),
                    _createElementVNode("button", {
                      class: "btn btn-outline-primary",
                      onClick: [
                        ($event: any) => (edit(reporttype)),
                        _cache[2] || (_cache[2] = _withModifiers(() => {}, ["stop"]))
                      ]
                    }, _hoisted_20, 8, _hoisted_18)
                  ])
                ])
              ]))
            }), 128))
          ])
        ])),
    _createVNode(ReportTypeModal, {
      id: `dictionary-reporttype-modal-add`,
      ref_key: "reportTypeModalAdd",
      ref: reportTypeModalAdd,
      operation: 'add'
    }, null, 512),
    _createVNode(ReportTypeModal, {
      id: `dictionary-reporttype-modal-edit`,
      ref_key: "reportTypeModalEdit",
      ref: reportTypeModalEdit,
      operation: 'edit'
    }, null, 512)
  ]))
}
}

})